import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '其他用例',
    type: 'SF_OTHER',
}
